import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import { getMerchantTerminalContractsQueryKey } from "Api/Queries/Merchants/useGetMerchantTerminalContractsQuery";
import {
  type UpdateMerchantTerminalContractCommandRequest,
  putMerchantsPublicIDTerminalContractsTerminalContractPublicID,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Params = {
  request: UpdateMerchantTerminalContractCommandRequest;
  merchantPublicID: string;
  terminalContractPublicID: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useUpdateMerchantTerminalContractMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ request, merchantPublicID, terminalContractPublicID }: Params) =>
        putMerchantsPublicIDTerminalContractsTerminalContractPublicID(
          request,
          merchantPublicID,
          terminalContractPublicID,
        ),
    ),
    onSuccess: (_, { merchantPublicID }: Params) => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.byMerchantPublicId(merchantPublicID),
      });
      queryClient.invalidateQueries({
        queryKey: getMerchantTerminalContractsQueryKey(merchantPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
